module.exports = __webpack_public_path__ + "static/media/cq_tabella b.9ac236c7.svg";